import { faCircleInfo, FaIcon } from '@/lib/fa'
import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

export const SelectDriversAndVehiclesInfoHelper = () => {
  const { t } = useLocalize()
  return (
    <>
      {/* Bottom helper row */}
      <div className="tw-flex tw-items-center tw-gap-3 tw-border-t tw-border-slate-200 tw-bg-slate-50 tw-px-4 tw-py-2.5 tw-text-xs tw-text-slate-600">
        <FaIcon icon={faCircleInfo} />
        <span>
          {t('importModule.select-active-hint')}{' '}
          <span className="tw-font-semibold">[{t('common.active')}]</span> {t('importModule.after-import')}.
        </span>
      </div>
    </>
  )
}
